/*
 * Auth store: This file stores an authentication relared information.
 * It is an auth store which holds information like isUserLoggedIn,SF access token.
 */

import {
    types,
    flow,
    ModelInstanceTypeProps,
    ModelProperties
} from 'mobx-state-tree';
import { CQAPIService } from '../../services/http-api.service';
import { CQAppStore } from '../cq-app-store';
import { CQAppConstant } from '../../app-constants';



const cqAPIService = new CQAPIService();
export const CQAuthModel = types
    .model({
        isUserLoggedIn: types.optional(types.boolean, false),
        accessToken: types.optional(types.string, ''),
        jwtAccessToken: types.optional(types.string, ''),
        isJWTAccessTokenValid: types.optional(types.boolean, false)
    })
    .actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
        setIsUserLoggedIn(isUserLoggedIn: boolean) {
            self.isUserLoggedIn = isUserLoggedIn;
        },
        setAccessToken(accessToken: string) {
            self.accessToken = accessToken;
        },
        setJWTAccessToken(JWTAccessToken: string) {
            self.jwtAccessToken = JWTAccessToken;
        },
        setIsJWTAccessToken(isJWTAccessToken: boolean) {
            self.isJWTAccessTokenValid = isJWTAccessToken;
        },
        fetchJWTAccessToken: flow(function* fetchJWTAccessToken() {
            try{
                const res = yield cqAPIService.authenicateUser(self.accessToken);
                self.jwtAccessToken = res.token;
                return self.jwtAccessToken;
            } catch (error : any) {
                CQAppStore.loader.setVisibility(false);
                const errorObj = {
                    errorType: CQAppConstant.ERROR_CUSTOM,
                    errorMessage: error.error ? error.error : error.message ,
                    errorStatus : error.status,
                    componentName: ''
                };
                CQAppStore.error.dispatchError(errorObj);
            }
        })
    }));


